
import { forwardRef, useContext, useImperativeHandle } from 'react'
import { motion } from "framer-motion";
import { Route, useLocation, useNavigate, useOutletContext, generatePath } from "react-router-dom";
import RoutePath from './../routes/RoutePathDefinition'
import Router from '../routes/Router'
import { SiteContext } from '../Root';

var SlideAnimatePage =forwardRef(({children, disableDrag}, ref)=>{
  useImperativeHandle(ref, () => ({

    goNext() {
      directionState[2].current =1
      var idx =Router.MatchPathFromPathArray(location.pathname, path_seq)
      if (idx>=path_seq.length-1){
        return
      }
      navigate(generatePath(path_seq[idx+1], {id:1}))
    },

    goPrevious(){
      directionState[2].current =-1
      var idx =Router.MatchPathFromPathArray(location.pathname, path_seq)
      if (idx===0){
        return
      }
      navigate(generatePath(path_seq[idx-1], {id:1}))
    }

  }));

  const navigate = useNavigate()
  const location = useLocation()
  const directionState = useContext(SiteContext)[0]
  const variants = {
    enter: (dir) => {
      return {
        y: dir[2].current ===0?0:(dir[2].current> 0 ? window.innerHeight : -window.innerHeight),
        opacity: 1,
        // zIndex:0,
      };
    },
    center: {
      y: 0,
      opacity: 1,
      // zIndex:1,
    },
    exit: (dir)=>{
      return{
        y: dir[2].current<0?window.innerHeight:-window.innerHeight,
        opacity: 1,
        // zIndex:0,
      }
    }
  }

  var path_seq =[
    RoutePath.INTRO.path,
  ]

  return(
    <motion.div
      custom={directionState}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      
      style={{position: 'absolute', left: '0', top: '0', width: '100%', height: '100%',}}

      // dragDirectionLock
      dragListener={!disableDrag}
      dragConstraints={{ right: 0, left: 0, top: 0, bottom: 0 }}
      dragElastic={1}
      
      transition={{
        y: { type: "spring", stiffness: 300, damping: 30 },
      }}
    >
      {children}
    </motion.div>
  )
})

export default SlideAnimatePage